<template>
    <v-toolbar :color="toolbarColor" dense elevation="0">
        <v-icon left>mdi-chart-line</v-icon>
        <v-toolbar-title>Statistics</v-toolbar-title>
        <v-spacer></v-spacer>
    </v-toolbar>
</template>

<script>
export default {
    name: 'reports-toolbar',
    computed: {
        toolbarColor() {
            return '#FFA800';
        }
    }
}
</script>